var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.colClass, _vm.childErrorClass]},[_vm._t("default"),(_vm.gotChildError)?_c('rpl-dev-error',{attrs:{"errors":_vm.childErrors}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }